<div class="comparison-layout">
  @if (loading()) {
    <!-- Mirrors .comparison-layout__labels: padding + spacer + panel skeleton -->
    <div
      class="comparison-layout__skeleton-labels"
      [style.width.px]="labelsWidth()"
    >
      <div
        class="comparison-layout__header-spacer"
        [style.height.px]="headerSpacerHeight()"
      ></div>
      <umss-skeleton [styles]="skeletonLabelPanelStyles()" />
    </div>
    @for (card of skeletonCards(); track card) {
      <umss-skeleton [styles]="skeletonCardStyles()" />
    }
  } @else {
    <div class="comparison-layout__labels" [style.width.px]="labelsWidth()">
      <div
        class="comparison-layout__header-spacer"
        [style.height.px]="headerSpacerHeight()"
      ></div>
      <div class="comparison-layout__labels-panel">
        <ng-content select="[comparison-label]" />
      </div>
    </div>

    <div
      class="comparison-layout__cards"
      [style.--card-header-min-height.px]="headerSpacerHeight()"
      [style.--card-max-width.px]="maxCardWidth()"
    >
      <ng-content select="[comparison-card]" />
    </div>
  }
</div>
